document.addEventListener("DOMContentLoaded", function () {
  const copyBtn = document.querySelector(".custom-copy-link");
  if (!copyBtn) return;

  const textSpan = copyBtn.querySelector("span");
  const originalText = textSpan.textContent;

  copyBtn.addEventListener("click", async () => {
    try {
      const url = window.location.href;
      await navigator.clipboard.writeText(url);

      textSpan.textContent = "Copied!";
      setTimeout(() => {
        textSpan.textContent = originalText;
      }, 2000);
    } catch (e) {}
  });
});
